function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Statistic, Button, Divider, Skeleton, Breadcrumb } from 'antd';
import axios from 'axios';
import Common from "../../components/includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Dashboard = function Dashboard() {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    keyStats = _useState2[0],
    setKeyStats = _useState2[1];
  useEffect(function () {
    axios.get("".concat(Common.baseApiUrl, "getkeystats/").concat(Common.currentUser.id.toString())).then(function (response) {
      if (response.data.status == 200) {
        setKeyStats(response.data.stats);
      }
    })["catch"](function (error) {
      console.log('Error');
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Breadcrumb, {
      style: {
        margin: '8px 0'
      },
      children: /*#__PURE__*/_jsx(Breadcrumb.Item, {
        children: "Tableau de bord"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "site-layout-background",
      style: {
        padding: 24,
        minHeight: 360
      },
      children: /*#__PURE__*/_jsxs(Container, {
        children: [Object.keys(keyStats).length === 0 ? /*#__PURE__*/_jsx(Skeleton, {
          active: true
        }) : /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 4,
              md: 4,
              children: /*#__PURE__*/_jsxs("div", {
                className: "focus-box-primary",
                children: [/*#__PURE__*/_jsx(Statistic, {
                  prefix: /*#__PURE__*/_jsx(UserOutlined, {}),
                  title: "Total utilisateurs",
                  value: keyStats.total.usercount
                }), /*#__PURE__*/_jsx(Button, {
                  style: {
                    marginTop: 16
                  },
                  type: "default",
                  children: "Gerer"
                })]
              })
            }), /*#__PURE__*/_jsxs(Col, {
              lg: 4,
              md: 4,
              children: [/*#__PURE__*/_jsx(Statistic, {
                prefix: /*#__PURE__*/_jsx(NotificationOutlined, {}),
                title: "Total avis",
                value: keyStats.total.adscount
              }), /*#__PURE__*/_jsx(Button, {
                style: {
                  marginTop: 16
                },
                type: "primary",
                children: "Gerer"
              })]
            }), /*#__PURE__*/_jsxs(Col, {
              lg: 4,
              md: 4,
              children: [/*#__PURE__*/_jsx(Statistic, {
                prefix: /*#__PURE__*/_jsx(AppstoreOutlined, {}),
                title: "Total entreprises",
                value: keyStats.total.companiescount
              }), /*#__PURE__*/_jsx(Button, {
                style: {
                  marginTop: 16
                },
                type: "primary",
                children: "Gerer"
              })]
            })]
          })
        }), /*#__PURE__*/_jsx(Divider, {}), Object.keys(keyStats).length === 0 ? /*#__PURE__*/_jsx(Skeleton, {
          active: true
        }) : /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 6,
            md: 6,
            children: /*#__PURE__*/_jsxs("div", {
              className: "focus-box-yellow",
              children: [/*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Nv(x) inscrit(s) jour",
                    value: keyStats.day.usercount
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total Avis jour",
                    value: keyStats.day.adscount
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 4,
                  md: 4,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Actifs/jour",
                    value: keyStats.day.activecount
                  })
                })]
              }), /*#__PURE__*/_jsxs(Row, {
                children: [/*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total ets jour",
                    value: keyStats.day.companiescount
                  })
                }), /*#__PURE__*/_jsx(Col, {
                  lg: 6,
                  md: 6,
                  children: /*#__PURE__*/_jsx(Statistic, {
                    title: "Total abonnements",
                    value: keyStats.day.subscriptionscount
                  })
                })]
              })]
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 6,
            md: 6,
            children: [/*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: "Nv(x) inscrit(s) semaine",
                  value: keyStats.week.usercount
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: "Total avis semaine",
                  value: keyStats.week.adscount
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 4,
                md: 4,
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: "Actifs/jour",
                  value: keyStats.week.activecount
                })
              })]
            }), /*#__PURE__*/_jsxs(Row, {
              children: [/*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: "Total ets semaine",
                  value: keyStats.week.companiescount
                })
              }), /*#__PURE__*/_jsx(Col, {
                lg: 6,
                md: 6,
                children: /*#__PURE__*/_jsx(Statistic, {
                  title: "Total abonnements",
                  value: keyStats.week.subscriptionscount
                })
              })]
            })]
          })]
        }), /*#__PURE__*/_jsx(Divider, {}), Object.keys(keyStats).length === 0 ? /*#__PURE__*/_jsx(Skeleton, {
          active: true
        }) : /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Nv(x) inscrit(s) Mois",
              value: keyStats.month.usercount
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Total avis Mois",
              value: keyStats.month.adscount
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Total ets mois",
              value: keyStats.month.companiescount
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 3,
            md: 3,
            children: /*#__PURE__*/_jsx(Statistic, {
              title: "Total abonnements",
              value: keyStats.month.subscriptionscount
            })
          })]
        })]
      })
    })]
  });
};
export default Dashboard;